<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="lg" :visible="modal.show" :data="model"
                   :title="model.uuid ? $t(`Update Category Term`) : $t(`Create New Category Term`)"
                   @show="onShow" @hidden="onHidden" @ok.prevent="onSubmit"
                   :show-confirmation="showConfirmation" :ok-title="$t('Submit')" :is-loading="loading"
                   scrollable modal-class="mobile-full-screen">

      <div class="row">
        <div class="col-md-6">
          <category-select-input-widget :model="model" attribute="category_uuid" :prop-items="categories"/>
        </div>
        <div class="col-md-6">
          <percentage-input-widget :model="model" attribute="tax_rate"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card mb-3">
            <div class="card-header">
              {{ $t("Commissions") }}
            </div>
            <div class="card-body">
              <commission-tiers :model="model" enable-first-tier-removal showMinimumCommissionField/>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card mb-3">
            <div class="card-header">
              {{ $t("Premiums") }}
            </div>
            <div class="card-body">
              <premium-tiers :model="model" enable-first-tier-removal show-minimum-premium-field/>
            </div>
          </div>
        </div>
      </div>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import AuctionCategoryTermModel from "@/modules/sales/view/terms/modals/AuctionCategoryTerm.model";
  import CategorySelectInputWidget from "@/core/widgets/CategorySelectInputWidget";
  import SalesService from "@/modules/sales/SalesService";
  import CommissionTiers from "@/core/components/commission-tiers/CommissionTiers";
  import Commission from "@/core/components/commission-tiers/Commission.model";
  import PremiumTiers from "@/core/components/premium-tiers/PremiumTiers";
  import Premium from "@/core/components/premium-tiers/Premium.model";
  import PercentageInputWidget from "@/core/widgets/PercentageInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('sales');

  export default {
    name: "AuctionCategoryTermModal",
    components: {
      PercentageInputWidget,
      PremiumTiers,
      CommissionTiers,
      CategorySelectInputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new AuctionCategoryTermModel(),
        categories: []
      }
    },
    computed: {
      ...mapState({
        modal: state => state.view.auctionCategoryTermsData.modal,
        editObject: state => state.view.auctionCategoryTermsData.modal.object,
        sale: state => state.view.auctionCategoryTermsData.modal.auction,
      }),
    },
    watch: {
      editObject() {
        if (this.editObject && this.editObject.uuid) {
          this.model = new AuctionCategoryTermModel(this.editObject);
          this.model.commissions = this.model.commissions.map(data => new Commission(data))
          this.model.premiums = this.model.premiums.map(data => new Premium(data))
        }
      },
      async sale() {
        if (this.sale) {
          let response = await SalesService.getSaleCategories(this.sale.uuid)
          if (response.success) {
            this.categories = response.body
          }
        }
      }
    },
    methods: {
      ...mapActions(['hideAuctionCategoryTermModal', 'createAuctionCategoryTerm', 'updateAuctionCategoryTerm']),
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new AuctionCategoryTermModel();
        this.hideAuctionCategoryTermModal();
        this.categories = []
      },
      async onSubmit() {
        this.$nextTick(() => {
          this.runSubmitLogic()
        });
      },
      async runSubmitLogic() {
        await this.$refs.observer.reset()

        let validateSuccess = await this.$refs.observer.validate()
        if (!validateSuccess) {
          return
        }

        if (this.model.commissions.length === 0 && this.model.premiums.length === 0 && !this.model.tax_rate) {
          this.$errorDialog(
              this.$i18n.t("Terms were not filled correctly. Fill commissions, premiums or tax rate, and try again"),
              this.$i18n.t("Auction Category Terms Validation")
          )
          return
        }

        this.model.resetErrors();
        this.model.premiums.forEach(p => p.resetErrors())
        this.model.commissions.forEach(c => c.resetErrors())
        this.model.auction_uuid = this.sale.uuid;

        let response;
        let message;
        if (!this.model.uuid) {
          response = await this.createAuctionCategoryTerm(this.model)
          message = this.$i18n.t('Sale category term was successfully created')
        } else {
          response = await this.updateAuctionCategoryTerm(this.model)
          message = this.$i18n.t('Sale category term was successfully updated')
        }

        if (response.success) {
          this.$toast('success', message)
          this.showConfirmation = false
          this.hideAuctionCategoryTermModal()
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0], this.$i18n.t("Auction Category Terms Validation"))
          } else {
            this.model.setErrors(response.body)
            if (response.body.premiums) {
              for (let index in response.body.premiums) {
                this.model.premiums[index].setMultipleErrors(response.body.premiums[index]);
              }
            }
            if (response.body.commissions) {
              for (let index in response.body.commissions) {
                this.model.commissions[index].setMultipleErrors(response.body.commissions[index]);
              }
            }
          }

        }
      },
    }
  }
</script>

<style scoped>

</style>

